export default __webpack_public_path__ + "static/media/1photo.672aa60e.jpg";